import { writable } from 'svelte/store';
export const BRAND_STORE = writable({});
export const BRAND_HASH = writable('initial');
